import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "core-scroll-up-button" },
    [
      _c(
        VBtn,
        {
          attrs: {
            color: "bg-gray-0",
            width: "40",
            height: "40",
            fab: "",
            "data-qa": "core-scroll-up-button",
            "aria-label": "Наверх",
          },
          on: { click: _setup.scrollToTop },
        },
        [
          _c(VIcon, { attrs: { color: "icon-secondary" } }, [
            _vm._v("\n      ui-icon-arrow-up\n    "),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }